import { createStore } from 'vuex';
import i18n from '../i18n';

export default new createStore({
    state: {
        fe_gHowToLoad: 'database',
        fe_project: 0,
        layout: 'app',
        is_show_sidebar: true,
        is_show_search: false,
        is_dark_mode: false,
        is_max_table: false,
        dark_mode: 'light',
        locale: null,
        menu_style: 'vertical',
        layout_style: 'full',
        countryList: [
            { code: 'zh', name: 'Chinese' },
            { code: 'da', name: 'Danish' },
            { code: 'en', name: 'English' },
            { code: 'fr', name: 'French' },
            { code: 'de', name: 'German' },
            { code: 'el', name: 'Greek' },
            { code: 'hu', name: 'Hungarian' },
            { code: 'it', name: 'Italian' },
            { code: 'ja', name: 'Japanese' },
            { code: 'pl', name: 'Polish' },
            { code: 'pt', name: 'Portuguese' },
            { code: 'ru', name: 'Russian' },
            { code: 'es', name: 'Spanish' },
            { code: 'sv', name: 'Swedish' },
            { code: 'tr', name: 'Turkish' },
        ],
        nudge3dActive: false,
        pdfOpen : false,
        pdfUrl: ''
    },
    mutations: {
        fe_setProject(state, value) {
            
            if (value && state.fe_project != value) {
                //one way trip for project from null to some value or to a different value
                state.fe_project = value
                console.log ("**************************************STORE SET: project changed to: " + state.fe_project)
            } else {
                console.log ("********************************** ***STORE SKIPPED", value, state.fe_project)
            }
        },
        setLayout(state, payload) {
            state.layout = payload;
        },
        toggleSideBar(state, value) {
            state.is_show_sidebar = value;
        },
        toggleSearch(state, value) {
            state.is_show_search = value;
        },
        toggleLocale(state, value) {
            value = value || 'en';
            i18n.global.locale = value;
            localStorage.setItem('i18n_locale', value);
            state.locale = value;
        },

        toggleDarkMode(state, value) {
            //light|dark|system
            value = value || 'light';
            localStorage.setItem('dark_mode', value);
            state.dark_mode = value;
            if (value == 'light') {
                state.is_dark_mode = false;
            } else if (value == 'dark') {
                state.is_dark_mode = true;
            } else if (value == 'system') {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    state.is_dark_mode = true;
                } else {
                    state.is_dark_mode = false;
                }
            }

            if (state.is_dark_mode) {
                document.querySelector('body').classList.add('dark');
            } else {
                document.querySelector('body').classList.remove('dark');
            }
        },

        toggleMenuStyle(state, value) {
            //horizontal|vertical|collapsible-vertical
            value = value || '';
            localStorage.setItem('menu_style', value);
            state.menu_style = value;
            if (!value || value === 'vertical') {
                state.is_show_sidebar = true;
            } else if (value === 'collapsible-vertical') {
                state.is_show_sidebar = false;
            }
        },

        toggleLayoutStyle(state, value) {
            //boxed-layout|large-boxed-layout|full
            value = value || '';
            localStorage.setItem('layout_style', value);
            state.layout_style = value;
        },
        TRIGGER_3D_NUDGE(state) {
            const expiry = localStorage.getItem('nudge_3d_mute_expiry');
            // If no mute exists or it has expired, show it
            if (!expiry || Date.now() > parseInt(expiry)) {
                state.nudgeActive = true;
            }
            },
        HIDE_3D_NUDGE(state) {
            state.nudgeActive = false;
            },
        MUTE_3D_NUDGE(state) {
            const TWO_WEEKS = 1209600000; //2 weeks
            //const TWO_WEEKS = 60000; //1 min for testing
            localStorage.setItem('nudge_3d_mute_expiry', (Date.now() + TWO_WEEKS).toString());
            state.nudgeActive = false;
            },
        setPdfModal(state, { isOpen, url = '' }) {
            console.log('setPdfModal',isOpen, url)
            state.pdfOpen = isOpen;
            state.pdfUrl = url;
        },
        closePdfModal(state) {
            state.pdfOpen = false;
            state.pdfUrl = '';
        }
    },
    getters: {
        project(state) {
            return state.fe_project;
        },
        layout(state) {
            return state.layout;
        },
        pdfOpen(state) {
            return state.pdfOpen;
        },
        pdfUrl(state) {
            return state.pdfUrl;
        }
    },
    actions: {},
    modules: {},
});
